import { useEffect, useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, Iconsvg, SelectField } from '@wk/components-react16';
import AuthService from "../../config/auth/auth.service";
import { RootState, store } from '../../store';
import { setAuthProject } from '../../store/authReducer';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import HttpService from "../../config/http.service";
import { API_URL } from '../../config/constants';
import { Toast } from '../../services';

const SelectProject = ({ data }: any) => {
    const { isOpenSelectProject, setIsOpenSelectProject } = data;
    const { authUser, authProject } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate();
    const { instance } = useMsal();
    const [currentProject, setCurrentProject] = useState(authProject ? authProject : null);
    const [projectList, setProjectList] = useState([] as any);
    const [isProject, setIsProject] = useState(false);

    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            if (authProject) setIsOpenSelectProject(false);
        }
    }

    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        const selected = projectList.find((item: any) => item.id == value);
        if (selected) {
            setCurrentProject(selected);
        } else {
            setCurrentProject(null);
        }
    };

    const handleSelectProject = () => {
        if (!currentProject?.id) {
            Toast('Please select Project', "error");
            return;
        }
        store.dispatch(setAuthProject({ ...currentProject }));
        navigate("/dashboard");
        HttpService.getRequest(`${API_URL.SET_PROJECT}/${currentProject.id}`).then(
        (res: any) => {
        },
        (err: any) => {
            Toast(err.message, "error");
        })
        setIsOpenSelectProject(false);
    }

    const handleCLoseProject = () => {
        if (authUser?.userType != 'ADMIN') {
            AuthService.logout(navigate, instance);
        }
        setIsOpenSelectProject(false);
    }

    const getProjects = () => {
        HttpService.getRequest(API_URL.GET_PROJECT).then(
        (res: any) => {
            setProjectList(res ? res :	[]);
            setIsProject(true);
        }, (err: any) => {
            Toast(err.message, "error");
            setIsProject(true);
        })
    }

    useEffect(() => {
        setIsProject(false);
        getProjects();
    }, []);

    return (
        <div>
            <Modal
                isOpen={isOpenSelectProject}
                srLabelledBy={'modal-id-project'}
                srDescribedBy={'modal-id-project'}
                onUserRequest={handleUserRequest}
                width={'432px'}>
                <ModalHeader
                    titleId={'modal-id-project'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => handleUserRequest('header')}>
                    Select Project
                </ModalHeader>
                <ModalBody descriptionId="modal-id-profile">
                    <div className='wk-grid-page-container p-0'>
                        <div className="wk-grid mt-20">
                            <div className="wk-column-12">
                                <SelectField size={'small'} label="" labelFor="select-id-project" indicator="required">
                                    <select id="select-id-project" name="project" value={currentProject?.id || ''}
                                        onChange={(event: any) => handleInputChange(event)}>
                                        <option value="">-- Select Project --</option>
                                        {projectList.map((item: any, i: number) => (
                                            <option value={item.id} key={i}>{item.name}</option>
                                        ))}
                                    </select>
                                </SelectField>
                                {isProject && projectList.length === 0 ? <div className="wk-text-center wk-text-danger flex">
                                    <Iconsvg name='info' size={20} color='red' />
                                    <span className='ml-10'>No associated projects. Contact your administrator.</span>
                                </div> : null}
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} iconPosition={'left'}>
                                {projectList.length > 0 ?
                                    <button
                                        className='mr-10'
                                        type="button"
                                        id="save"
                                        disabled={currentProject ? false : true}
                                        onClick={handleSelectProject}>
                                        Save
                                    </button>
                                    : <button
                                        className='mr-10'
                                        type="button"
                                        id="close"
                                        onClick={handleCLoseProject}>
                                        Close
                                    </button>
                                }
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default SelectProject;